/**
 * Extracts initials from a user name
 * Handles format: "LastName, FirstName (SSO)"
 * @param {string} name - Full name from MSAL
 * @return {string} Two-letter initials
 */
export const extractInitials = (name) => {
  if (!name || name === 'NA') {
    return 'NA';
  }

  const nameParts = name.split(','); // Split by comma
  const lastName = nameParts[0]?.trim();
  const firstName = nameParts[1]?.split('(')[0]?.trim();

  const lastInitial = lastName?.charAt(0).toUpperCase() || '';
  const firstInitial = firstName?.charAt(0).toUpperCase() || '';

  return `${lastInitial}${firstInitial}` || 'NA';
};
